import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'gbc-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  @HostBinding('class.no-shadow') noShadow = false;

  constructor() {}
}
